import React from "react"
import { Search } from "lucide-react"
import { Input } from "@/components/ui/input"
import { isMobile } from "../utils/detectDevice"
import { useTranslation } from "react-i18next"

type SearchBarProps = {
  value: string
  onValueChange: (value: string) => void
  inPopover?: boolean
}

const SearchBar = ({ value, onValueChange, inPopover }: SearchBarProps) => {
  const { t } = useTranslation()
  return (
    <div className="relative w-full">
      <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-400" />
      <Input
        autoFocus={!!inPopover}
        type="search"
        placeholder={t("app.chatList.searchPlaceholder")}
        value={value}
        onChange={(e) => onValueChange(e.target.value)}
        className={`rounded-md border-b-input bg-white pl-10 dark:bg-input/30 ${
          isMobile ? "text-base" : "h-9"
        }`}
      />
    </div>
  )
}

export default React.memo(SearchBar)
